import {createGlobalStyle} from 'styled-components'

export const GlobalFont = createGlobalStyle`

@import url('https://fonts.googleapis.com/css2?family=Kaisei+Decol:wght@400;500&display=swap');


h1{
    font-family: 'Kaisei Decol', serif;
  }
   p{
    font-family: 'Kaisei Decol', serif;
   }


`

